import type { ReactNode } from 'react';
import type { FriendlyError } from '@london-life/errors';
import { Button } from '@london-life/ui/components/button';

type Props = { error: FriendlyError; onRetry?: () => void; children?: ReactNode };

// the one way every screen shows a failure: the plain message and Retry when it can help. The request's
// reference stays in the logs (and the response) for support; players are never shown it (Jerry, 10 October)
export function ErrorNotice({ error, onRetry, children }: Props) {
  return (
    <div className="error-notice" role="alert">
      <p className="error-notice-message">{error.message}</p>
      {children}
      {error.retryable && onRetry && (
        <div className="error-notice-footer">
          <Button type="button" size="sm" variant="outline" onClick={onRetry}>
            Try again
          </Button>
        </div>
      )}
    </div>
  );
}
